/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyApiRateLimitRow } from "./CompanyApiRateLimitRow";
import {
  CompanyApiRateLimitRowFromJSON,
  CompanyApiRateLimitRowFromJSONTyped,
  CompanyApiRateLimitRowToJSON,
  CompanyApiRateLimitRowToJSONTyped,
} from "./CompanyApiRateLimitRow";

/**
 *
 * @export
 * @interface CompanyApiRateLimitsResponse
 */
export interface CompanyApiRateLimitsResponse {
  /**
   *
   * @type {Array<CompanyApiRateLimitRow>}
   * @memberof CompanyApiRateLimitsResponse
   */
  limits: Array<CompanyApiRateLimitRow>;
  /**
   *
   * @type {boolean}
   * @memberof CompanyApiRateLimitsResponse
   */
  enforcementEnabled: boolean;
}

/**
 * Check if a given object implements the CompanyApiRateLimitsResponse interface.
 */
export function instanceOfCompanyApiRateLimitsResponse(
  value: object,
): value is CompanyApiRateLimitsResponse {
  if (!("limits" in value) || value["limits"] === undefined) return false;
  if (
    !("enforcementEnabled" in value) ||
    value["enforcementEnabled"] === undefined
  )
    return false;
  return true;
}

export function CompanyApiRateLimitsResponseFromJSON(
  json: any,
): CompanyApiRateLimitsResponse {
  return CompanyApiRateLimitsResponseFromJSONTyped(json, false);
}

export function CompanyApiRateLimitsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyApiRateLimitsResponse {
  if (json == null) {
    return json;
  }
  return {
    limits: (json["limits"] as Array<any>).map(CompanyApiRateLimitRowFromJSON),
    enforcementEnabled: json["enforcementEnabled"],
  };
}

export function CompanyApiRateLimitsResponseToJSON(
  json: any,
): CompanyApiRateLimitsResponse {
  return CompanyApiRateLimitsResponseToJSONTyped(json, false);
}

export function CompanyApiRateLimitsResponseToJSONTyped(
  value?: CompanyApiRateLimitsResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    limits: (value["limits"] as Array<any>).map(CompanyApiRateLimitRowToJSON),
    enforcementEnabled: value["enforcementEnabled"],
  };
}
